// Polyfills for older browsers
// Once Parcel 2 supports differential serving, we can separate out
// the babel / react polyfills into their own bundle that's loaded via a
// script tag with `nomodule`, so we don't include the polyfills for all browsers.
import 'zdocs-web-core/lib/polyfills';

import 'zdocs-web-core/theme/modern-reset.css';
import 'zdocs-web-core/theme/zdocs-reset.css';
import 'normalize.css/normalize.css';

import React from 'react';
import ReactDOM from 'react-dom';

import { ErrorBoundary } from 'zdocs-web-core/lib/error';
import { rumInit, Service } from 'zdocs-web-core/lib/rum';
import { TokenInfo } from 'zdocs-web-core/lib/token';
import { getTokenFromUrl } from 'zdocs-web-core/lib/doc-editor';
import App from './App';

let tokenInfo: TokenInfo | undefined;
try {
  tokenInfo = getTokenFromUrl();
} catch (e) {}

rumInit(Service.StandaloneEditor, tokenInfo);

ReactDOM.render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>,
  document.getElementById('root')
);
